<template>
  <div id="Bu" v-show="true">

    <div class="tableItem1 no-border-top">
      <div class="tips" style="margin:0 9px;">
        <img src="../../assets/jpg/tips.svg" alt="" />
        <span class="china">每日16:00更新昨日数据，所有数据统计从2026/05/14开始</span>
      </div>
      <div v-if="loading1" v-loading="loading1" style="height: 60px"></div>
      <div v-else>
        <div class="title" style="padding: 0px 11px 0px;margin:25px auto">
          <span class="titleBIg china">品牌各渠道达成</span>
          <span class="titleSmall china">截至{{ RefreshTime | dateFormat }}</span>
        </div>
        <tableBrand :ChangeFlag="ActiveFlag" :TableList1="tableData" :AllMyData="AllData" v-if="dataShow"></tableBrand>
        <div v-else v-loading='loading' style="height:60px">
          <tableBrand></tableBrand>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tableBrand from "./tableBrand.vue";
import qs from "qs";
export default {
  data() {
    return {
      ActiveFlag: 'tab3',
      tableData: [],
      AllData: null,
      TotalData: [],
      DCLData: [],
      NoDCLData: [],
      dataShow: false,
      AliFlag: false,
      loading: true,
      loading1: true,
      RefreshTime: '',
    };
  },
  methods: {
    getTablist() {
      this.$addr
        .post("SalesNew/getDCL")
        .then((res) => {
          this.tableData = res.data.data;
          this.dataShow = true;
          this.loading1 = false;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getAllData() {
      this.$addr
        .post("SalesNew/getDCLTotal")
        .then((res) => {
          this.AllData = res.data.data[0] || null;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getTime() {
      this.$addr
        .post("SalesNew/getSalesFGSRealTimeRefreshData")
        .then((res) => {
          this.RefreshTime = res.data.data.t1_date;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
  },
  components: {
    tableBrand,
  },
  created() {
    this.getTablist();
    this.getAllData();
    this.getTime();
  },
};
</script>
<style scoped>
.china {
  font-family: "微软雅黑" !important;
}

#Bu {
  /* padding: 25px 14px 0;
  border-radius: 20px 0 20px 20px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  overflow: hidden; */
  border-radius: 0 0 20px 20px;
  height: 100%;
  overflow: hidden;
}

.tableItem1 {
  margin: 0 auto 12px;
  padding: 25px 14px 0;
  border-radius: 0 20px 20px 20px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}


.tips {
  background: #ededed;
  border-radius: 5px;
  text-align: center;
  padding: 2px;
}

.tips span {
  font-family: "Heiti SC";
  font-style: normal;
  font-weight: normal;
  font-size: 9px;
  line-height: 20px;
  color: #000;
}

.title {
  margin: 25px auto 35px;
  color: #000;
}

.title .titleBIg {
  font-size: 22px;
  margin-right: 15px;

}

.title .titleSmall {
  font-size: 12px;
  /* transform: scale(.9); */
}

.listItem {
  margin: 25px auto;
}

.listItem p {
  font-size: 10px !important;
  line-height: 12px;
  font-weight: bold;
  margin-bottom: 6px;
}

.china {
  font-family: "微软雅黑" !important;
}

.listItem1 {
  margin: 5px auto;
}

.bgColor {
  opacity: .6;
}

.tableItemImg {
  position: absolute;
  top: 20%;
  bottom: 0;
  margin: auto;
  right: 0;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-top-color: #001BA7;
}

.redPlusActiveImg {
  -webkit-transform: rotate(-180deg) !important;
  transform: rotate(-180deg) !important;
  top: -50%;
}

.no-border-top {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/WarRoom/Bu.vue